import React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import {getGeneratorMsg, generatorMessages} from '../../../../constants/TextConst';

@observer
class GeneratorWhen extends Component<any, any> {
    field;

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.field = this.props.field;
    }

    handleChange(e) {
        this.field.setIsOrOp(e.target.value === 'Or');
    }

    render() {
        const {field} = this.props;
        return (
            <div className="when-panel-area">
                <span>{getGeneratorMsg(generatorMessages.whenPanelTitleText)}</span>
                <div
                    className="radio-btn-area"
                    id="and-or"
                    defaultValue={field.isOrOp ? 'Or' : 'And'}
                >
                    <label className={classNames('radio-btn', 'right', {active: field.isOrOp})}>
                        <input
                            type="radio"
                            name="and-or"
                            /*checked={field.isOrOp}*/ value="Or"
                            onChange={this.handleChange}
                        />
                        <span>{getGeneratorMsg(generatorMessages.toggleOrText)}</span>
                    </label>
                    <label className={classNames('radio-btn', 'left', {active: !field.isOrOp})}>
                        <input
                            type="radio"
                            name="and-or"
                            /*checked={!field.isOrOp}*/ value="And"
                            onChange={this.handleChange}
                        />
                        <span>{getGeneratorMsg(generatorMessages.toggleAndText)}</span>
                    </label>
                </div>
                {/*<ButtonToolbar>
    				<ToggleButtonGroup type="radio" name="options" defaultValue={field.isOrOp ? 'or' : 'and'} onChange={this.handleChange}>
    	  				<ToggleButton value={'and'}>And</ToggleButton>
      					<ToggleButton value={'or'}>Or</ToggleButton>
    				</ToggleButtonGroup>
  				</ButtonToolbar>*/}
                {/*<input type="radio" name="when-panel-group" id="when-1" checked/>
				<label className="label-when-1">and</label>
				<input type="radio" name="when-panel-group" id="when-2"/>
				<label className="label-when-2">or</label>*/}
            </div>
        );
    }
}

export default GeneratorWhen;
